export default "__VITE_ASSET__8236c266__"